// Utilities for event handlers

import type {SyntheticEvent} from "react";

/**
 * Prevent default action for wrapped JSX event handler, and return false on event.
 * @param fn inner function to call on event
 * @return wrapped event handler
 */
export function handlePreventDefault<E extends SyntheticEvent>(fn: (event: E) => void): (event: E) => boolean {
    return (e) => {
        if (e && typeof e.preventDefault === "function") {
            e.preventDefault();
        }
        if (typeof fn === "function") {
            fn(e);
        }
        return false;
    };
}
